import React from 'react'

import { Icon } from '@clientbase/clientbase-library'
import { Box, Typography } from '@mui/material'

import { theme } from 'styles/theme'

interface CustomerMenuItemProps {
  isMobile?: boolean
  icon: string | React.ReactNode
  label: string
  onClick: () => void
  iconProps?: any
}

const CustomerMenuItem: React.FC<CustomerMenuItemProps> = ({
  icon,
  label,
  onClick,
  iconProps,
  isMobile
}) => (
  <Box
    display="flex"
    alignItems="center"
    gap={2}
    p={isMobile ? '4px' : '8px'}
    sx={{
      borderRadius: '8px',
      cursor: 'pointer',
      '&:hover': { bgcolor: '#f5f5f5' }
    }}
    onClick={onClick}
  >
    {typeof icon === 'string' ? <Icon icon={icon} {...iconProps} /> : icon}
    <Typography
      sx={{ textWrap: 'nowrap' }}
      variant="smLight"
      color={theme.palette.neutral[200]}
    >
      {label}
    </Typography>
  </Box>
)

export default CustomerMenuItem
